// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"account_wrapper__12eCi"};